<template>
<select class="standard-duration-options">
	<option value="1">1 day</option>
	<option value="2">2 days</option>
	<option value="3">3 days</option>
	<option value="4">4 days</option>
	<option value="5">5 days</option>
	<option value="6">6 days</option>
	<option value="7">7 days</option>
	<option value="8">8 days</option>
	<option value="9">9 days</option>
	<option value="10">10 days</option>
	<option value="11">11 days</option>
	<option value="12">12 days</option>
	<option value="13">13 days</option>
	<option value="14">14 days</option>
	<option value="15">15 days</option>
	<option value="16">16 days</option>
	<option value="17">17 days</option>
	<option value="18">18 days</option>
	<option value="19">19 days</option>
	<option value="20">20 days</option>
	<option value="21">21 days</option>
	<option value="22">22 days</option>
	<option value="23">23 days</option>
	<option value="24">24 days</option>
	<option value="25">25 days</option>
	<option value="26">26 days</option>
	<option value="27">27 days</option>
	<option value="28">28 days</option>
	<option value="29">29 days</option>
	<option value="30">30 days</option>
	<option value="31">31 days</option>
</select>
</template>

<script>

export default {
  name: "StandardDurationOptions"
}

</script>

<style scoped>

</style>